import {Component, Inject, OnInit, signal} from '@angular/core';
import {DecorationsService} from '../../services/decorations/decorations.service';
import {Decoration} from '../../classes/decoration.class';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PushpinPart} from '../../classes/pushpinpart.class';
import {MaterialService} from '../../services/material/material.service';
import {Material} from '../../classes/material.class';
import {CustomerArea} from "../../classes/customerarea.class";
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-pushpin-part-creation-wizard',
    templateUrl: './pushpin-part-creation-wizard.component.html',
    styleUrls: ['./pushpin-part-creation-wizard.component.scss'],
    imports: [
        MatButton
    ]
})
export class PushpinPartCreationWizardComponent implements OnInit {

    public readonly amountInput = signal('_');
    public readonly type = signal<string>(null);
    public readonly group = signal<string>(null);
    public readonly types = signal<string[]>([]);
    public readonly groups = signal<string[]>([]);
    public readonly decorations = signal<Decoration[]>([]);
    public readonly amountsList = signal<number[]>([]);
    public pushpinPart: PushpinPart;
    public readonly materials = signal<Material[]>([]);
    public lengthmark: boolean;
    public copy: boolean;
    private _decorations: Decoration[];
    private customerArea: CustomerArea;

    materialList: Material[];

    constructor(
        private decorationsService: DecorationsService,
        private materialService: MaterialService,
        private dialogRef: MatDialogRef<PushpinPartCreationWizardComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            lengthmark: boolean,
            copy?: boolean,
            customerArea: CustomerArea
        }) {
        this.lengthmark = data.lengthmark;
        this.copy = data.copy;
        this.customerArea = data.customerArea;
        const amounts = [];
        for (let i = 1; i < 10; i++) {
            amounts.push(i);
        }
        this.amountsList.set(amounts);
    }

    ngOnInit() {
        this.initData();

    }

    public backspaceAmountInput() {
        this.amountInput.update(value => {
            const newValue = (value + '').substring(0, (value + '').length - 1);
            return newValue || '_';
        });
    }

    public setAmountInput(number) {
        this.amountInput.update(value => {
            if (value === '_') {
                return '' + number;
            } else if (value) {
                return (value + '' + number);
            } else {
                return number;
            }
        });
    }

    selectMaterial(material) {
        this.pushpinPart.material = material;
        this.pushpinPart.material_id = material.id;

        if (material.id === 10) {
            this.group.set('Vlak');
            this.selectDecoration(this.decorations().find(decoration => {
                return decoration.id === 36;
            }));
        } else if (material.id === 5) {
            this.group.set('Voorgevormd');
            this.decorations.update(decs => decs.filter(decoration => {
                return ['Voorgevormd'].indexOf(decoration.decoration_group) !== -1;
            }));
        } else {
            this.groups.update(groups => groups.filter(group => {
                return group !== 'Voorgevormd';
            }));
            if (this.groups().length === 1) {
                this.filterGroup(this.groups()[0]);
            }
        }
        if (this.type() === 'Diversen vervangen') {
            this.selectAmount(1);
        }
    }

    selectDecoration(decoration) {
        this.pushpinPart.decoration = decoration;
        this.pushpinPart.decoration_id = decoration.id;
        if (this.pushpinPart.material.primer) {
            const primer = this.materialList.sort((a, b) => a.sort_order - b.sort_order)
                .find(m => m.kind === 'Primer' &&
                    ['both', (this.pushpinPart.decoration.specific_price && this.pushpinPart.decoration.surface ? 'figuration' : 'material')].includes(m.suitable_kind) &&
                    m.suitable_materials.includes(this.pushpinPart.material_id)
                );
            this.pushpinPart.primer = primer.id;
        }
        if (this.copy) {
            this.pushpinPart.amount = null;
            this.dialogRef.close(this.pushpinPart);
        } else if ((decoration.specify_length || !decoration.surface) && this.pushpinPart.material_id) {
            this.selectAmount(1);
        }
    }

    selectAmount(amount) {
        if (!amount || amount < 1 || amount === '_') {
            amount = 1;
        }
        this.pushpinPart.amount = amount;
        this.dialogRef.close(this.pushpinPart);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    filterType(type: string) {
        if (type === 'Lengtemarkering') {
            this.materials.update(mats => mats.filter(_material => {
                return _material.id !== 5 && _material.id !== 10;
            }));
        }
        this.type.set(type);
        this.decorations.set(this._decorations.filter(decoration => {
            return decoration.type === type;
        }));
        const newGroups = [];
        this.decorations().forEach(decoration => {
            if (newGroups.indexOf(decoration.decoration_group) === -1) {
                newGroups.push(decoration.decoration_group);
            }
        });
        this.groups.set(newGroups);
        if (this.groups().length === 1) {
            this.filterGroup(this.groups()[0]);
        }
    }

    filterGroup(group: string) {
        this.group.set(group);
        this.decorations.update(decs => decs.filter(decoration => {
            return decoration.decoration_group === group;
        }));
        if (this.decorations().length === 1) {
            this.selectDecoration(this.decorations()[0]);
        }
    }

    breadcrumBack(backToStep) {
        if (backToStep === 3) {
            this.filterGroup(this.group());
            this.pushpinPart.decoration = null;
            this.pushpinPart.decoration_id = null;
        }
        if (backToStep === 2) {
            this.group.set(null);
            this.pushpinPart.decoration = null;
            this.pushpinPart.decoration_id = null;
            this.filterType(this.type());
            this.selectMaterial(this.pushpinPart.material);
        }
        if (backToStep === 1) {
            this.filterType(this.type());
            this.pushpinPart.material_id = null;
        }
        if (backToStep < 1) {
            this.type.set(null);
            this.group.set(null);
            this.initData();
        }


    }

    private initData() {
        this.pushpinPart = new PushpinPart();
        this.materialService.getMaterials(true).then(materials => {
            this.materials.set(materials.filter(m => m.usable));
            this.materialList = materials.filter(m => !m.usable);
        });


        this.decorationsService.getList(this.customerArea).then(decorations => {
            this._decorations = decorations;
            const newTypes = [];
            this._decorations.forEach(decoration => {
                if (newTypes.indexOf(decoration.type) === -1) {
                    if (decoration.type) {
                        newTypes.push(decoration.type);
                    }
                }
            });
            this.types.set(newTypes);
            if (this.lengthmark) {
                this.filterType('Lengtemarkering');
            }
        });
    }

}
